export const STORAGE_KEY = 'genai-app-banner-dismissed';

/** Set on `<html>` before first paint by `AppBannerDismissedScript`. */
export const DISMISSED_ATTRIBUTE = 'data-app-banner-dismissed';
